<div class="df gap10">
    <mat-form-field [appearance]="appearance" [class]="fieldClass" [floatLabel]="floatLabel" style="width: 90px; min-width: 90px; max-width: 90px;" *ngIf="withCountry">
        <mat-select class="select-panel" panelClass="dialog-select-panel" disableOptionCentering="true" [formControl]="country"
                    (selectionChange)="countrySelected($event.value)">
            <mat-option *ngFor="let country of countries" [value]="country">
                {{ country.code }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field [appearance]="appearance" [class]="fieldClass" [floatLabel]="floatLabel">
        <mat-label>{{ label | translate }}</mat-label>
        <ng-container *ngIf="autoFocus">
            <input matInput
                   [prefix]="prefix"
                   [mask]="mask"
                   cdkFocusInitial
                   [formControl]="phone"
                   (input)="numberChanged()"
                   [class]="{'field-with-action-button': callAllowed && phone?.value}"
                   (paste)="onInputPaste($event.clipboardData?.getData('text/plain'))">
        </ng-container>
        <ng-container *ngIf="!autoFocus">
            <input matInput
                   [prefix]="prefix"
                   [mask]="mask"
                   [formControl]="phone"
                   (input)="numberChanged()"
                   [class]="{'field-with-action-button': callAllowed && phone?.value}"
                   (paste)="onInputPaste($event.clipboardData?.getData('text/plain'))">
        </ng-container>
        <div class="field-action-button" *ngIf="callAllowed && phone?.value">
            <button class="item-action-button gray" (click)="call()">
                <mat-icon class="call-icon">phone_enabled</mat-icon>
            </button>
        </div>
    </mat-form-field>
</div>
